
interface LocalBusinessProps {
  name: string;
  description: string;
  url: string;
  telephone: string;
  address: {
    streetAddress?: string;
    addressLocality?: string;
    addressRegion: string;
    postalCode?: string;
    addressCountry: string;
  };
  geo?: {
    latitude: number;
    longitude: number;
  };
  image?: string;
  priceRange?: string;
  openingHoursSpecification?: {
    dayOfWeek: string[] | string;
    opens: string;
    closes: string;
  }[];
}

/**
 * Generate LocalBusiness schema for counties and regions
 */
export function generateLocalBusinessSchema(business: LocalBusinessProps) {
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": business.name,
    "description": business.description,
    "url": business.url,
    "telephone": business.telephone,
    "address": {
      "@type": "PostalAddress",
      ...business.address
    },
    ...(business.geo && {
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": business.geo.latitude,
        "longitude": business.geo.longitude
      }
    }),
    ...(business.image && { "image": business.image }),
    ...(business.priceRange && { "priceRange": business.priceRange }),
    ...(business.openingHoursSpecification && {
      "openingHoursSpecification": business.openingHoursSpecification.map(hours => ({
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": hours.dayOfWeek,
        "opens": hours.opens,
        "closes": hours.closes
      }))
    })
  };
}
